import { Box, useMediaQuery } from '@mui/material';
import { IconButton } from '../../../packages/ui/molecules/icon-button';
import { btnType } from '../../../packages/ui/atoms/button';
import { theme } from '../../../packages/theme';
import { colors } from '../../../packages/colors';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import cx from 'clsx';

import { scheduleActionCreators } from '../../../redux/modules/schedule';
import { getAuth } from '../../../redux/modules/auth/selectors';
import { updateProviderSchedule } from '../../../services/schedule/schedule.service';
import { getUserTimeZone } from '../../../utils/dayjs';

import Heading from '../../../components/v2/Heading';
import { HeadingLevel, HeadingWeight } from '../../../components/v2/Heading/index.types';
import Typography from '../../../components/v2/Typography';
import { typography } from '../../../components/v2/Typography/index.constant';
import SlotCard from './components/SlotCard';

import { useStyles } from './index.styles';

const AvailableSlots = ({
  slots,
  providerSchedule,
  currentDate,
  setOpenBlockedWholeDay,
  setShowDayAvailability,
  setSchedulesDrawerOpen,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const { meta } = useSelector(getAuth);

  return (
    <Box className={classes.cflex} gap={4}>
      <Box className={classes.sbflex2}>
        <Heading variant={HeadingLevel.SUB} fontWeight={HeadingWeight.SEMI_BOLD}>
          Available slots
        </Heading>
        {!isTablet && (
          <Box className={classes.rflex} gap={4}>
            <Box sx={{ '& button': { gap: 1, color: colors.destructive600 } }}>
              <IconButton onClick={() => setOpenBlockedWholeDay(true)}>
                <Typography {...typography.body.normal.medium.bold}>Block all</Typography>
              </IconButton>
            </Box>
            <Box sx={{ '& button': { gap: 1, color: colors.primary600 } }}>
              <IconButton icon="plus" onClick={() => setShowDayAvailability(true)}>
                <Typography {...typography.body.normal.medium.bold}>Add slot</Typography>
              </IconButton>
            </Box>
          </Box>
        )}
      </Box>
      <Box className={classes.cflex} gap={2}>
        {slots.map((slot, index) => {
          return (
            <SlotCard
              key={index}
              slot={slot}
              actions={[
                {
                  variant: btnType.OUTLINE,
                  className: cx(classes.blockBtn, classes.xsmallBtn),
                  children: 'Block',
                  onClick: async () => {
                    await updateProviderSchedule(meta?.userId, {
                      availability: [
                        {
                          slots: [
                            {
                              start: dayjs(slot?.start).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                              end: dayjs(slot?.end).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                            },
                          ],
                          active: false,
                          removed: true,
                        },
                      ],
                      timezone: providerSchedule?.timezone || getUserTimeZone(),
                    });
                    const endOfDay = currentDate.endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                    const startOfDay = currentDate.startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSSZ');
                    dispatch(
                      scheduleActionCreators.fetchDailySchedule({
                        userId: meta.userId,
                        queryParams: {
                          startTime: startOfDay,
                          endTime: endOfDay,
                        },
                      }),
                    );
                  },
                },
                {
                  variant: btnType.OUTLINE,
                  className: cx(classes.xsmallBtn, classes.primaryBorder),
                  children: 'Book appointment',
                  onClick: () => setSchedulesDrawerOpen(true),
                },
              ]}
            />
          );
        })}
        {isTablet && (
          <Box display="flex" justifyContent="space-between" paddingRight="2px">
            <Box sx={{ '& button': { gap: 1, color: colors.primary600 } }}>
              <IconButton icon="plus" onClick={() => setShowDayAvailability(true)}>
                <Typography {...typography.body.normal.medium.bold}>Add slot</Typography>
              </IconButton>
            </Box>
            <Box sx={{ '& button': { gap: 1, color: colors.destructive600 } }}>
              <IconButton onClick={() => setOpenBlockedWholeDay(true)}>
                <Typography {...typography.body.normal.medium.bold}>Block all</Typography>
              </IconButton>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AvailableSlots;
